import { useState, useEffect } from 'preact/hooks';
import { useFilter } from '../../contexts/FilterContext';
import { fetchBalanceSheetStackedData } from '../../functions/calculations';
import type { StackedBarData } from '../../components/charts/StackedBarChart';

export function useUnitBalanceSheet() {
  const { selectedClient, selectedUnit } = useFilter();
  const [stackedBarData, setStackedBarData] = useState<{ xLabels: string[]; stacks: StackedBarData[] }>({
    xLabels: [],
    stacks: [],
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!selectedClient?.user_id_no || !selectedUnit?.unit_id_no) {
      setStackedBarData({ xLabels: [], stacks: [] });
      return;
    }

    const fetchBalanceData = async () => {
      setLoading(true);
      try {
        const data = await fetchBalanceSheetStackedData(
          selectedClient.user_id_no,
          selectedUnit.unit_id_no!
        );
        setStackedBarData(data);
      } catch (error) {
        console.error('Error fetching balance sheet stacked data:', error);
        setStackedBarData({ xLabels: [], stacks: [] });
      } finally {
        setLoading(false);
      }
    };

    fetchBalanceData();
  }, [selectedClient, selectedUnit]);

  return { stackedBarData, loading };
}
